import { Component, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { ValueSetReference } from 'src/app/models/value-set-reference.model';
import { sortLocale, sortOptions } from '../../sorting';
import { ValueSetScopeViewModel } from '../value-set-scope.viewmodel';
import { ValueSetViewModel } from '../value-set.viewmodel';
import { ValueSetsDialogModel } from './value-sets-dialog.model';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-value-sets-dialog',
    templateUrl: './value-sets-dialog.component.html',
    styleUrls: ['./value-sets-dialog.component.scss'],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatCheckbox, MatDialogActions, MatButton]
})
export class ValueSetsDialogComponent {
  dialogRef = inject<MatDialogRef<ValueSetsDialogComponent>>(MatDialogRef);
  dialogModel = inject<ValueSetsDialogModel>(MAT_DIALOG_DATA);


  public scopes: ValueSetScopeViewModel[];
  public code: string;
  public display: string;

  private pinnedValueSets: ValueSetReference[];

  constructor() {
    const dialogModel = this.dialogModel;

    this.code = dialogModel.code;
    this.display = dialogModel.display;

    const valueSetsByScope = new Map<string, ValueSetViewModel[]>();
    dialogModel.valueSets.forEach(vs => {
      const isPinned = !!dialogModel.pinnedValueSets.find(pvs => pvs.scope === vs.scope && pvs.name === vs.name);

      const vsViewModel = new ValueSetViewModel(vs, isPinned);

      const forScope = valueSetsByScope.get(vs.scope);
      if (!forScope) {
        valueSetsByScope.set(vs.scope, [vsViewModel]);
      } else {
        forScope.push(vsViewModel);
      }
    });

    this.scopes = [];
    this.pinnedValueSets = [...dialogModel.pinnedValueSets];

    valueSetsByScope.forEach((valueSets, key) => {
      valueSets.sort((a, b) => a.cleanName.localeCompare(b.cleanName, sortLocale, sortOptions));
      this.scopes.push(new ValueSetScopeViewModel(key, valueSets));
    });

    this.scopes.sort((a, b) => a.scope.localeCompare(b.scope, sortLocale, sortOptions));
  }

  onPinnedChanged(valueSet: ValueSetViewModel, checked: boolean): void {
    if (checked) {
      this.pinnedValueSets.push(valueSet.reference);
    } else {
      const index = this.pinnedValueSets.findIndex(vs => vs.isMatch(valueSet.reference));
      this.pinnedValueSets.splice(index, 1);
    }
  }

  onCloseClick(): void {
    this.dialogRef.close(this.pinnedValueSets);
  }
}
